import { useStoreContext } from "../../contexts/StoreDataContext";
import FeaturedFooter from "./FeaturedFooter";
import RegularFooter from "./RegularFooter";

const Footer = () => {
  const context = useStoreContext();
  // const storeData = context?.storeData;
  const isProplanActive = context.isProplanActive;

  //console.log("))",storeData);
  // const hideHeroMedia = storeData?.hideHeroMedia;
  // const homePageEnabled = storeData?.homePageEnabled;

  // const homeActive = useMemo(() => {
  //   return isProplanActive ?? (!!homePageEnabled && !hideHeroMedia);
  // }, [hideHeroMedia, isProplanActive, homePageEnabled]);

  if (isProplanActive) return <FeaturedFooter />;
  return <RegularFooter />;
};

export default Footer;
